<template>
	<h4 v-if="title && title.length > 0">
		{{title}}

		<!-- Lock/Unlock-->
		<a @click="editMode=!editMode" v-if="view == 'toggle' && canEdit">
			<i class="pi pi-lock" v-if="!editMode" />
			<i class="pi pi-unlock" v-if="editMode" />
		</a>
	</h4>

	<!-- Cards View-->
	<div class="col-12 flex flex-row flex-wrap" v-if="(editMode && view=='toggle') || view=='cards'">
		<template v-for="cont in visibleContacts" :key="cont.contactId">
			<div class="card mr-3 mb-3" style="width: 480px;">
				<i @click="removeContact(cont)" class="pi pi-times" style="cursor:pointer;float:right;top:-10px;position:relative;"></i>

				<div class="field">
					<label>First name</label>
					<InputText v-model="cont.firstName" @change="ensureEmptyContact" />
				</div>
				<div class="field">
					<label>Last name</label>
					<InputText v-model="cont.lastName" />
				</div>
				<div class="field">
					<label>Job title</label>
					<InputText v-model="cont.jobTitle" />
				</div>
				<div class="field">
					<label>Email</label>
					<InputText v-model="cont.email" />
				</div>
				<div class="field">
					<label>Enable automation emails</label>
					<br />
					<InputSwitch v-model="cont.enableAutomationEmails" />
				</div>
				<div class="field">
					<label>Mobile</label>
					<InputText v-model="cont.mobile" />
				</div>
				<div class="field">
					<label>DDI</label>
					<InputText v-model="cont.ddi" />
				</div>
			</div>
		</template>
	</div>

	<!-- Read only indented-list view-->
	<div v-if="(!editMode && view=='toggle') || view == 'indented-list'">
		<div class="flex flex-wrap">
			<template v-for="cont in visibleContacts" :key="cont.contactId">
				<div class="col-3 item-border-left" style="min-width:300px;">
					<div class="mt-2">{{cont.firstName}} {{cont.lastName}}</div>
					<div class="ml-3 mt-1" v-if="cont.jobTitle != null && cont.jobTitle.length > 1"><i>{{cont.jobTitle}}</i></div>
					<div class="ml-3 mt-1 text-wrap"><a :href="'mailto:' + cont.email">{{cont.email}}</a></div>
					<div class="ml-3 mt-1"><a :href="'tel:' + cont.mobile">{{cont.mobile}}</a></div>
					<div class="ml-3 mt-1"><a :href="'tel:' + cont.ddi">{{cont.ddi}}</a></div>
				</div>
			</template>
		</div>
	</div>
</template>

<script lang="ts">
	import { Vue, Options } from 'vue-class-component';
	import { ContactData } from '../api-client/api-client'

	@Options({
		name: 'Contact',
		components: {
		},
		props: {
			title: {
				type: String,
				default: ""
			},
			contacts: {
				type: Array,
				default: []
			},
			view: {
				type: String,
				default: 'cards'
			},
			canEdit: {
				type: Boolean,
				default: false
			},
		}
	})
	export default class Contacts extends Vue {
		contacts: ContactData[] = [];

		editMode = false;	

		ensureEmptyContact() {
			if (!this.contacts) {
				this.contacts = [];
			}

			if (!this.editMode)
				return;

			if (this.contacts.length == 0) {
				this.newContact();
				return;
			}

			const lastContact: ContactData = this.contacts[this.contacts.length - 1];
			if (this.isValidContact(lastContact)) {
				this.newContact();
			}
		}

		newContact() {
			if (this.contacts == null) {
				this.contacts = [];
			}

			const emptycontact = new ContactData;
			emptycontact.active = true;
			this.contacts.push(emptycontact);
			return;
		}

		removeContact(contact: ContactData) {
			if (this.contacts.length > 0) {
				const index = this.contacts.indexOf(contact);
				if (index > -1) {
					if (contact.contactId == null) {
						this.contacts.splice(index, 1);
					}
					contact.whenDeleted = new Date();
				}
			}
		}

		isValidContact(contact: ContactData) {
			return contact.contactId != null
				|| contact.firstName != null
				|| contact.lastName != null
				|| contact.jobTitle != null
				|| contact.email != null
				|| contact.mobile != null
				|| contact.ddi != null
		}

		get visibleContacts() {
			this.ensureEmptyContact();
			return this.contacts.filter(c => c.whenDeleted == null);
		}
	}
</script>

<style scoped lang="scss">

	// for prime icon lock/unlock
	.pi {
		font-size: 1.5rem;
		margin-left: 10px;
		top: 1px;
		position:relative;
	}
</style>